import { apiSlice } from "./apiSlice";
import {
  PaginatedUsersResponse,
  UserEntity,
} from "../../services/users/user.types";

export interface GetUsersPaginatedArgs {
  page: number;
  pageSize: number;
  id?: number;
  email?: string;
  /** Búsqueda libre por nombre, apellido o username (SCRUM-1095). */
  q?: string;
}

export interface UsersPage {
  data: UserEntity[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
}

export const usersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsersPaginated: builder.query<UsersPage, GetUsersPaginatedArgs>({
      query: ({ page, pageSize, id, email, q }) => ({
        url: "/users/paginated",
        method: "GET",
        params: {
          page,
          pageSize,
          // The backend filters by `userId`; the app-facing arg is `id`.
          ...(id !== undefined && { userId: id }),
          ...(email && { email }),
          ...(q && { q }),
        },
      }),
      transformResponse: (response: PaginatedUsersResponse): UsersPage => ({
        data: response.data,
        pagination: {
          page: response.page,
          pageSize: response.pageSize,
          total: response.total,
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "User" as const, id })),
              { type: "User" as const, id: "LIST" },
            ]
          : [{ type: "User" as const, id: "LIST" }],
    }),
    deleteUser: builder.mutation<void, number>({
      query: (id) => ({
        url: `/users/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),
  }),
});

export const { useGetUsersPaginatedQuery, useDeleteUserMutation } = usersApi;
